import React from 'react';
import { Modal, Button as BootstrapButton } from 'react-bootstrap';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { usePedidosListagem, usePedidosNavegacao } from '../hooks';
import PedidosHeader from './PedidosHeader';
import PedidosTable from './PedidosTable';
import PedidosFilter from './PedidosFilter';

const PedidosCard = ({
  cargaId,
  showActions = true,
  enableRowClick = true,
  showFilter = true,
  showHeader = true
}) => {
  // Hooks
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    showDeleteModal,
    pedidoToDelete,
    handleFilterApply,
    handleLimparFiltros,
    handleExcluir,
    confirmDelete,
    cancelDelete,
    setPaginaAtual,
    setQuantidadePorPagina
  } = usePedidosListagem(cargaId);
  const {
    handleRowClick,
    handleAdicionar,
    handleEditar
  } = usePedidosNavegacao();
  return <>
      <Card>
        <CardBody>
          {showHeader && <PedidosHeader totalRegistros={totalRegistros} onAdicionar={showActions ? handleAdicionar : undefined} />}
          
          {showFilter && <PedidosFilter loading={filterLoading} onApply={handleFilterApply} onLimpar={handleLimparFiltros} />}
          
          <PedidosTable data={data} loading={loading} onRowClick={enableRowClick ? handleRowClick : undefined} onEditar={showActions ? handleEditar : undefined} onExcluir={showActions ? handleExcluir : undefined} manualPagination={true} totalRegistros={totalRegistros} controlledPagination={{
          pageIndex: Math.max(0, (paginaAtual || 1) - 1),
          pageSize: quantidadePorPagina || 10
        }} onPaginationChange={next => {
          // Atualiza pageSize e página (pageIndex é zero-based na tabela)
          if (next && typeof next.pageSize === 'number') {
            setQuantidadePorPagina(next.pageSize);
          }

          if (next && typeof next.pageIndex === 'number') {
            setPaginaAtual(next.pageIndex + 1);
          }
        }} />
        </CardBody>
      </Card>

      {
      /* Modal de Confirmação de Exclusão */
    }
      <Modal show={showDeleteModal} onHide={cancelDelete} animation={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Tem certeza que deseja excluir o pedido <strong>{pedidoToDelete?.numeroDoPedido}</strong>?
          </p>
          <p className="text-muted">
            Esta ação não pode ser desfeita.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <BootstrapButton variant="secondary" onClick={cancelDelete}>
            Cancelar
          </BootstrapButton>
          <BootstrapButton variant="danger" onClick={confirmDelete}>
            Excluir
          </BootstrapButton>
        </Modal.Footer>
      </Modal>
    </>;
};

export default PedidosCard;
